import styled from "styled-components";
import CSS from "csstype";

interface TextContainerI {
    color?: string
    fontSize?: CSS.Property.FontSize
    fontWeight?: CSS.Property.FontWeight
    letterSpacing?: CSS.Property.LetterSpacing

}

const TextContainer = styled.div<TextContainerI>`
  color: ${props => props.color ?? "var(--text-color-main)"};
  font-size: ${props => props.fontSize ?? "14px"};
  font-weight: ${props => props.fontWeight ?? "500"};
  letter-spacing: ${props => props.letterSpacing ?? "0"};
`

export default TextContainer